import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useDebounce } from "use-debounce";
import SearchBox from "../../SearchBox";

const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  // Global filter only works with pagination from the first page.
  // This may not be a problem for server side pagination when
  // only the current page is downloaded.

  const [query, setQuery] = useState(globalFilter);
  const [debounceQuery] = useDebounce(query, 700);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    setGlobalFilter(query);
  }, [debounceQuery]);

  return (
    <SearchBox
      value={query || ""}
      onChange={handleChange}
      name="global-filter"
    />
  );
};

GlobalFilter.propTypes = {
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
};

GlobalFilter.defaultProps = {
  globalFilter: null,
};

export default GlobalFilter;
